/**
 * @generated SignedSource<<7d14fc5cef419148952c027271e53ec2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bookmarkHeaderFeaturesArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "bookmarkHeaderFeaturesArticle";
};
export type bookmarkHeaderFeaturesArticle$key = {
  readonly " $data"?: bookmarkHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"bookmarkHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "bookmarkHeaderFeaturesArticle"
};

(node as any).hash = "c8d26c1603efb3d4f94b435b41ce26bd";

export default node;
